<template>
  <div class="container">
    <HeadingOne class="-margin-md">メンテナンス中</HeadingOne>

    <section class="_mb-sm-60 _mb-md-120">
      <p>
        ただいまシステムメンテナンス中です。<br />
        終了次第、サービスを再開いたしますので、いましばらくお待ちください。<br />
        ご迷惑をおかけし誠に申し訳ございませんが、ご理解のほどよろしくお願い申しあげます。
      </p>
    </section>
  </div>
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Tem027",
  components: {
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "メンテナンス中",
      description: "",
      keywords: "",
    });
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
